module.exports = __webpack_public_path__ + "img/Frente-56-02 open.997d9b64.jpg";